/**
 * A safe separator string separator
 * @example
 * ```
 * separate('data, test,prop ,for , string) // returns ['data', 'test', 'prop', 'for', 'string']
 * ```
 * @param data {string} The string that will be separated
 * @param separator {string} Split character
 * @returns {Array<string>}
 */
export const separate = (data: any, separator: string): string[] =>
    typeof data !== 'string' || !separator
        ? data
        : (data || '')
              .split(separator)
              .map((seg) => seg.trim())
              .filter((item) => item && item.length > 0);
